// extracted by mini-css-extract-plugin
export default {"relativePosition":"KYJ5XG2cuvLgLCWHAWeo"};